import { useNavigate } from 'react-router-dom'
import { LoginPage } from '@betstarters/ui'
import { useAuth } from '@/hooks/use-auth'
import api from '@/api/client'

export function LoginPageWrapper() {
  const { refreshUser } = useAuth()
  const navigate = useNavigate()

  return (
    <LoginPage
      subtitle="Site Builder"
      api={api}
      onSuccess={async () => {
        await refreshUser()
        navigate('/')
      }}
    />
  )
}
